(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(function () {
  var drawer, sid, changeUrl, busyResetTimer;

  function q(sel, root) { return (root || document).querySelector(sel); }

  function setCount(n) {
    if (n === null || n === undefined) return;
    document.querySelectorAll('.icons .cart .count, [data-cart-count-text]').forEach(function (el) {
      el.textContent = n;
    });
  }

  function lockScroll(on) {
    document.documentElement.style.overflow = on ? 'hidden' : '';
    document.body.style.overflow = on ? 'hidden' : '';
  }

  function open() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    var close = q('.cart-drawer__close', drawer);
    if (close) close.focus();
  }

  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    lockScroll(false);
  }

  function applyHTML(html) {
    if (!html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var next = parsed.querySelector('[data-drawer-body]');
    var cur = q('[data-drawer-body]', drawer);
    if (next && cur) {
      cur.innerHTML = next.innerHTML;
      var c = cur.querySelector('[data-cart-count]');
      if (c) setCount(c.getAttribute('data-cart-count'));
    }
  }

  function busy(on) {
    if (!drawer) return;
    if (on) { drawer.setAttribute('data-busy', ''); }
    else { drawer.removeAttribute('data-busy'); }
  }

  function refreshDrawer() {
    if (!drawer) return;
    var sep = window.location.search ? window.location.search + '&' : '?';
    fetch(window.location.pathname + sep + 'sections=' + sid, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) { applyHTML(data[sid]); })
      .catch(function () {});
  }

  function changeQty(key, qty) {
    if (!drawer) return;
    busy(true);
    fetch(changeUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: sid, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections && data.sections[sid]) { applyHTML(data.sections[sid]); }
        else { refreshDrawer(); }
        setCount(data.item_count);
        busy(false);
      })
      .catch(function () { busy(false); refreshDrawer(); });
  }

  function onClick(e) {
    if (!e.target || !e.target.closest) return;
    /* Open from the header cart icon, or any element opting in explicitly
       (the mobile menu's cart link). */
    var trigger = e.target.closest('a.cart, [data-cart-drawer-open]');
    if (trigger && drawer) { e.preventDefault(); open(); return; }
    if (!drawer) return;
    if (e.target.closest('[data-cd-close]')) { e.preventDefault(); close(); return; }
    if (!drawer.contains(e.target)) return;
    var step = e.target.closest('[data-cd-step]');
    if (step) {
      var box = step.closest('.cd-qtybox');
      var input = box ? box.querySelector('input') : null;
      if (input) {
        var v = parseInt(input.value, 10); if (isNaN(v)) v = 0;
        v = Math.max(0, v + parseInt(step.getAttribute('data-cd-step'), 10));
        changeQty(input.getAttribute('data-key'), v);
      }
      return;
    }
    var rm = e.target.closest('[data-cd-remove]');
    if (rm) { changeQty(rm.getAttribute('data-key'), 0); }
  }

  function onChange(e) {
    var input = e.target.closest('[data-cd-qty]');
    if (input && drawer && drawer.contains(input)) {
      var v = parseInt(input.value, 10); if (isNaN(v) || v < 0) v = 0;
      changeQty(input.getAttribute('data-key'), v);
    }
  }

  function init() {
    drawer = document.getElementById('CartDrawer');
    if (!drawer) return; /* disabled or not present */
    sid = drawer.getAttribute('data-section-id');
    changeUrl = drawer.getAttribute('data-change-url');
    if (!document.body.dataset.cdBound) {
      document.body.dataset.cdBound = '1';
      document.addEventListener('click', onClick);
      document.addEventListener('change', onChange);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
      /* The add request already asked for this section, so the new line item is
         painted BEFORE the panel slides in. Only fall back to a second request
         when the markup did not come back with the response. */
      document.addEventListener('cart:added', function (e) {
        var html = e.detail && e.detail.sections && e.detail.sections[sid];
        if (html) { applyHTML(html); open(); }
        else { open(); refreshDrawer(); }
      });
    }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function reveal(el) { el.classList.add('is-in'); }
  function init(scope) {
    var root = (scope && scope.querySelectorAll) ? scope : document;
    root.querySelectorAll('.chero--anim').forEach(function (h) {
      if (h.dataset.cheroReady) return;
      h.dataset.cheroReady = '1';
      if (reduce || !('IntersectionObserver' in window)) { reveal(h); return; }
      try {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); } });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
        io.observe(h);
      } catch (err) { reveal(h); }
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(document); }); }
  else { init(document); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-toolbar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(el) { el.classList.add('is-in'); }
  function initReveal(scope) {
    var root = (scope && scope.querySelectorAll) ? scope : document;
    root.querySelectorAll('.colsec--anim').forEach(function (s) {
      if (s.dataset.canimReady) return;
      s.dataset.canimReady = '1';
      if (reduce || !('IntersectionObserver' in window)) { reveal(s); return; }
      try {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); } });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
        io.observe(s);
      } catch (err) { reveal(s); }
    });
  }

  function initToolbar(scope) {
    var root = scope.getElementById ? scope.getElementById('CollectionNav') : scope.querySelector('#CollectionNav');
    if (root && !root.dataset.ready) {
      root.dataset.ready = '1';

      /* Custom category dropdown */
      var drop = root.querySelector('[data-cdrop]');
      if (drop) {
        var toggle = drop.querySelector('[data-cdrop-toggle]');
        function closeDrop() { drop.classList.remove('is-open'); if (toggle) toggle.setAttribute('aria-expanded', 'false'); }
        function openDrop() { drop.classList.add('is-open'); if (toggle) toggle.setAttribute('aria-expanded', 'true'); }
        if (toggle) {
          toggle.addEventListener('click', function (e) {
            e.stopPropagation();
            if (drop.classList.contains('is-open')) { closeDrop(); } else { openDrop(); }
          });
        }
        document.addEventListener('click', function (e) { if (!drop.contains(e.target)) closeDrop(); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrop(); });
      }

      /* Sort — native, reloads with sort_by (preserves any active filter params) */
      var sortSel = root.querySelector('[data-col-sort-select]');
      if (sortSel) { sortSel.addEventListener('change', function () { sortSel.form.submit(); }); }

      /* In-collection live search over products on the page; Enter → native search */
      var input = root.querySelector('[data-col-search-input]');
      if (input) {
        /* The grid is server-rendered and does not change between keystrokes, so
           the cards and their lowercased titles are collected once (same approach
           as the blog filter in main-blog.liquid) instead of re-querying the whole
           grid — plus a nested h3 lookup per card — on every character typed.
           Filtering is then debounced, so a burst of typing runs it once. */
        var searchCards = null;
        var searchTimer = null;

        var collectCards = function () {
          searchCards = [];
          document.querySelectorAll('.pgrid .pcard').forEach(function (c) {
            var h = c.querySelector('h3');
            searchCards.push({ el: c, title: h ? h.textContent.toLowerCase() : '' });
          });
        };

        var applySearch = function () {
          searchTimer = null;
          if (!searchCards) { collectCards(); }
          var q = input.value.trim().toLowerCase();
          searchCards.forEach(function (c) {
            c.el.hidden = q !== '' && c.title.indexOf(q) === -1;
          });
        };

        input.addEventListener('input', function () {
          clearTimeout(searchTimer);
          searchTimer = setTimeout(applySearch, 200);
        });
      }

      /* Grid / list view toggle */
      var viewBtns = root.querySelectorAll('[data-col-view]');
      function applyView(mode) {
        var grid = document.querySelector('.pgrid');
        if (grid) grid.classList.toggle('is-list', mode === 'list');
        viewBtns.forEach(function (b) {
          var on = b.getAttribute('data-col-view') === mode;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }
      try { var saved = window.localStorage.getItem('hcc-view'); if (saved) applyView(saved); } catch (e) {}
      viewBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          var mode = b.getAttribute('data-col-view');
          applyView(mode);
          try { window.localStorage.setItem('hcc-view', mode); } catch (e) {}
        });
      });

      /* Mobile filter button — future-ready hook for the Filters phase */
      var filterBtn = root.querySelector('[data-col-filter]');
      if (filterBtn) {
        filterBtn.addEventListener('click', function () {
          document.dispatchEvent(new CustomEvent('collection:toggle-filters'));
        });
      }

      /* Optional sticky navigation — fixed-position with a spacer (no layout jump).
         Auto-detects the header height and whether the header is sticky. */
      if (root.dataset.sticky === 'true') {
        var bar = root.querySelector('.cbar');
        if (bar) {
          var behavior = root.dataset.stickyBehavior || 'always';
          var threshold = parseInt(root.dataset.stickyThreshold, 10) || 0;
          var spacer = document.createElement('div');
          spacer.className = 'cbar-spacer';
          spacer.setAttribute('aria-hidden', 'true');
          var stuck = false;
          var naturalTop = 0;
          function measure() { if (!stuck) { naturalTop = bar.getBoundingClientRect().top + window.pageYOffset; } }
          function headerOffset() {
            var h = document.querySelector('#header') || document.querySelector('header');
            if (h) { var p = window.getComputedStyle(h).position; if (p === 'fixed' || p === 'sticky') { return Math.round(h.getBoundingClientRect().height); } }
            return 0;
          }
          function stick() {
            if (stuck) return;
            spacer.style.height = bar.offsetHeight + 'px';
            bar.parentNode.insertBefore(spacer, bar);
            bar.classList.add('is-stuck');
            stuck = true;
          }
          function unstick() {
            if (!stuck) return;
            bar.classList.remove('is-stuck');
            if (spacer.parentNode) spacer.parentNode.removeChild(spacer);
            bar.style.top = '';
            stuck = false;
          }
          var ticking = false;
          function refresh() {
            ticking = false;
            var y = window.pageYOffset;
            var off = headerOffset();
            var trigger = (behavior === 'after') ? threshold : (naturalTop - off);
            if (trigger < 0) { trigger = 0; }
            if (y >= trigger) { stick(); bar.style.top = off + 'px'; } else { unstick(); }
          }
          function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(refresh); } }
          measure();
          window.addEventListener('scroll', onScroll, { passive: true });
          window.addEventListener('resize', function () { unstick(); measure(); refresh(); });
          refresh();
        }
      }
    }
    initReveal(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initToolbar(document); });
  } else {
    initToolbar(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initToolbar(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initSlider(scope) {
    var root = (scope && scope.querySelectorAll) ? scope : document;
    root.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
      if (slider.dataset.ready) return;
      slider.dataset.ready = '1';
      var track = slider.querySelector('[data-slider-track]');
      var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-slide]'));
      if (!track || slides.length === 0) return;
      var fade = slider.getAttribute('data-effect') === 'fade';
      var loop = slider.getAttribute('data-loop') !== 'false';
      var autoplay = slider.getAttribute('data-autoplay') !== 'false' && !reduce;
      var speed = parseInt(slider.getAttribute('data-autoplay-speed'), 10) || 5000;
      var swipe = slider.getAttribute('data-swipe') !== 'false';
      if (fade) slider.classList.add('hero-slider--fade');
      var i = 0, timer = null, dots = [];
      var dotsWrap = slider.querySelector('[data-slider-dots]');
      if (dotsWrap) {
        slides.forEach(function (s, n) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Go to slide ' + (n + 1));
          b.addEventListener('click', function () { go(n); reset(); });
          dotsWrap.appendChild(b);
          dots.push(b);
        });
      }
      function render() {
        if (fade) { slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); }); }
        else { track.style.transform = 'translateX(' + (-i * 100) + '%)'; }
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      }
      function go(n) {
        if (n < 0) { n = loop ? slides.length - 1 : 0; }
        if (n >= slides.length) { n = loop ? 0 : slides.length - 1; }
        i = n; render();
      }
      function next() { go(i + 1); }
      function prev() { go(i - 1); }
      function play() { if (autoplay && slides.length > 1 && !timer) { timer = setInterval(next, speed); } }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function reset() { stop(); play(); }
      var pv = slider.querySelector('[data-slider-prev]'); if (pv) { pv.addEventListener('click', function () { prev(); reset(); }); }
      var nx = slider.querySelector('[data-slider-next]'); if (nx) { nx.addEventListener('click', function () { next(); reset(); }); }
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', play);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', play);
      if (swipe) {
        var x0 = null;
        slider.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        slider.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) { if (dx < 0) { next(); } else { prev(); } reset(); }
          x0 = null;
        });
      }
      render();
      play();
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { initSlider(document); }); }
  else { initSlider(document); }
  document.addEventListener('shopify:section:load', function (e) { initSlider(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
(function () {
  function initArticleProgress(scope) {
    var root = scope && scope.querySelector ? scope : document;
    var wrap = root.querySelector ? root.querySelector('[data-article-progress]') : null;
    if (!wrap || wrap.dataset.ready === '1') { return; }
    var bar = wrap.querySelector('[data-article-progress-bar]');
    var article = wrap.closest('.article') || document.querySelector('.article');
    if (!bar || !article) { return; }
    wrap.dataset.ready = '1';

    var ticking = false;

    function update() {
      ticking = false;
      var rect = article.getBoundingClientRect();
      var total = article.offsetHeight - window.innerHeight;
      var p;
      if (total > 0) {
        p = (-rect.top) / total;
      } else {
        p = rect.top <= 0 ? 1 : 0;
      }
      if (p < 0) { p = 0; } else if (p > 1) { p = 1; }
      bar.style.transform = 'scaleX(' + p + ')';
    }

    function onScroll() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initArticleProgress(document); });
  } else {
    initArticleProgress(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initArticleProgress(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealIn(scope) {
    var host = scope.querySelector ? scope.querySelector('.bloghub--anim') : null;
    if (scope.classList && scope.classList.contains('bloghub--anim')) { host = scope; }
    if (!host) { return; }
    var items = host.querySelectorAll('.reveal');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
  }

  function initBlogHub(scope) {
    var root = (scope && scope.querySelector) ? (scope.matches && scope.matches('[data-bloghub]') ? scope : scope.querySelector('[data-bloghub]')) : document.querySelector('[data-bloghub]');
    if (!root || root.dataset.ready === '1') { revealIn(root || document); return; }
    root.dataset.ready = '1';

    var drop = root.querySelector('[data-bh-drop]');
    var toggle = root.querySelector('[data-bh-toggle]');
    var label = root.querySelector('[data-bh-label]');
    var items = Array.prototype.slice.call(root.querySelectorAll('.bh-drop__item'));
    var input = root.querySelector('[data-bh-input]');
    var clearBtn = root.querySelector('[data-bh-clear]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-bh-card]'));
    var empty = root.querySelector('[data-bh-empty]');

    var grid = root.querySelector('[data-bh-grid]');
    var pager = root.querySelector('[data-bh-pager]');
    var pageSize = parseInt(grid && grid.getAttribute('data-page-size'), 10) || 12;

    var state = { tag: root.dataset.defaultCat || '', q: '', page: 1 };

    function isFilterActive() { return state.tag !== '' || state.q !== ''; }

    /* Every article is in the DOM, so category + search match across ALL of them
       instantly (not just the current page). Pagination is then applied to the
       matching set below. */
    function matches() {
      var q = state.q.trim().toLowerCase();
      return cards.filter(function (card) {
        var tags = (card.getAttribute('data-tags') || '').split(',');
        var matchTag = state.tag === '' || tags.indexOf(state.tag) !== -1;
        if (!matchTag) { return false; }
        if (!q) { return true; }
        var hay = (card.getAttribute('data-title') || '') + ' ' + (card.getAttribute('data-excerpt') || '') + ' ' + (card.getAttribute('data-tags') || '');
        return hay.indexOf(q) !== -1;
      });
    }

    var CHEV_L = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>';
    var CHEV_R = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';

    function edge(dir, enabled) {
      var inner = dir === 'prev' ? (CHEV_L + '<span>Prev</span>') : ('<span>Next</span>' + CHEV_R);
      if (enabled) { return '<button type="button" class="bh-pager__edge" data-nav="' + dir + '" aria-label="' + (dir === 'prev' ? 'Previous' : 'Next') + ' page">' + inner + '</button>'; }
      return '<span class="bh-pager__edge is-disabled" aria-hidden="true">' + inner + '</span>';
    }

    function pageList(cur, total) {
      var keep = [], out = [], prev = 0, i;
      for (i = 1; i <= total; i++) { if (i === 1 || i === total || (i >= cur - 1 && i <= cur + 1)) { keep.push(i); } }
      keep.forEach(function (p) { if (prev && p - prev > 1) { out.push('gap'); } out.push(p); prev = p; });
      return out;
    }

    function buildPager(pages) {
      if (!pager) { return; }
      if (pages <= 1) { pager.hidden = true; pager.innerHTML = ''; return; }
      pager.hidden = false;
      var html = edge('prev', state.page > 1) + '<div class="bh-pager__pages">';
      pageList(state.page, pages).forEach(function (n) {
        if (n === 'gap') { html += '<span class="bh-pager__gap" aria-hidden="true">&hellip;</span>'; }
        else if (n === state.page) { html += '<span class="bh-pager__num is-current" aria-current="page">' + n + '</span>'; }
        else { html += '<button type="button" class="bh-pager__num" data-page="' + n + '" aria-label="Page ' + n + '">' + n + '</button>'; }
      });
      html += '</div>' + edge('next', state.page < pages);
      pager.innerHTML = html;
    }

    function render() {
      var list = matches();
      var total = list.length;
      var pages = Math.max(1, Math.ceil(total / pageSize));
      if (state.page > pages) { state.page = pages; }
      if (state.page < 1) { state.page = 1; }
      var start = (state.page - 1) * pageSize;
      cards.forEach(function (c) { c.classList.add('is-hidden'); });
      list.slice(start, start + pageSize).forEach(function (c) { c.classList.remove('is-hidden'); });
      if (empty) { empty.hidden = total !== 0; }
      if (clearBtn) { clearBtn.hidden = !isFilterActive(); }
      buildPager(pages);
    }

    function scrollToTop() {
      if (!grid) { return; }
      var header = document.querySelector('#header') || document.querySelector('header');
      var off = 0;
      if (header) { var pos = window.getComputedStyle(header).position; if (pos === 'fixed' || pos === 'sticky') { off = Math.round(header.getBoundingClientRect().height); } }
      var top = grid.getBoundingClientRect().top + window.pageYOffset - off - 24;
      window.scrollTo({ top: top < 0 ? 0 : top, behavior: reduce ? 'auto' : 'smooth' });
    }

    function goTo(p) { state.page = p; render(); scrollToTop(); }
    function filterChanged() { state.page = 1; render(); }

    /* Pager clicks (delegated) */
    if (pager) {
      pager.addEventListener('click', function (e) {
        var numBtn = e.target.closest ? e.target.closest('[data-page]') : null;
        var navBtn = e.target.closest ? e.target.closest('[data-nav]') : null;
        if (numBtn) { goTo(parseInt(numBtn.getAttribute('data-page'), 10)); }
        else if (navBtn) { goTo(navBtn.getAttribute('data-nav') === 'prev' ? state.page - 1 : state.page + 1); }
      });
    }

    /* Dropdown open/close */
    function closeDrop() { if (drop) { drop.classList.remove('is-open'); } if (toggle) { toggle.setAttribute('aria-expanded', 'false'); } }
    function openDrop() { if (drop) { drop.classList.add('is-open'); } if (toggle) { toggle.setAttribute('aria-expanded', 'true'); } }
    if (toggle) {
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        if (drop.classList.contains('is-open')) { closeDrop(); } else { openDrop(); }
      });
    }
    document.addEventListener('click', function (e) { if (drop && !drop.contains(e.target)) { closeDrop(); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrop(); } });

    /* Category selection */
    items.forEach(function (item) {
      item.addEventListener('click', function () {
        state.tag = item.getAttribute('data-filter') || '';
        items.forEach(function (i) {
          var on = i === item;
          i.classList.toggle('is-active', on);
          var li = i.closest('[role="option"]');
          if (li) { li.setAttribute('aria-selected', on ? 'true' : 'false'); }
        });
        if (label) { label.textContent = item.textContent.trim(); }
        closeDrop();
        filterChanged();
      });
    });

    /* Search */
    if (input) {
      input.addEventListener('input', function () { state.q = input.value || ''; filterChanged(); });
    }

    /* Clear all */
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        state.tag = '';
        state.q = '';
        if (input) { input.value = ''; }
        items.forEach(function (i) {
          var on = (i.getAttribute('data-filter') || '') === '';
          i.classList.toggle('is-active', on);
          var li = i.closest('[role="option"]');
          if (li) { li.setAttribute('aria-selected', on ? 'true' : 'false'); }
        });
        if (label && items.length) { label.textContent = items[0].textContent.trim(); }
        filterChanged();
      });
    }

    render();
    revealIn(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initBlogHub(document); });
  } else {
    initBlogHub(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initBlogHub(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function () {
  function initCartPage() {
    var form = document.getElementById('cart-form');
    if (!form || form.dataset.cartReady) return;
    form.dataset.cartReady = '1';
    var timer = null;
    var submitSoon = function () {
      clearTimeout(timer);
      timer = setTimeout(function () { form.submit(); }, 650);
    };
    form.querySelectorAll('[data-qty]').forEach(function (box) {
      var input = box.querySelector('.qtybox__input');
      if (!input) return;
      box.querySelectorAll('[data-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = parseInt(input.value, 10);
          if (isNaN(v)) v = 0;
          v = Math.max(0, v + parseInt(btn.getAttribute('data-dir'), 10));
          input.value = v;
          submitSoon();
        });
      });
      input.addEventListener('change', submitSoon);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartPage);
  } else {
    initCartPage();
  }
  document.addEventListener('shopify:section:load', initCartPage);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(scope) {
    var root = (scope && scope.querySelectorAll) ? scope : document;
    root.querySelectorAll('.collection-head').forEach(function (h) {
      if (h.dataset.ready) return;
      h.dataset.ready = '1';
      if (reduce || !('IntersectionObserver' in window)) { h.classList.add('is-in'); return; }
      try {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
        io.observe(h);
      } catch (err) { h.classList.add('is-in'); }
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(document); }); }
  else { init(document); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
(function () {
  function initSearch(scope) {
    var root = (scope && scope.querySelector) ? (scope.matches && scope.matches('[data-srch]') ? scope : scope.querySelector('[data-srch]')) : document.querySelector('[data-srch]');
    if (!root || root.dataset.ready === '1') { return; }
    root.dataset.ready = '1';

    var designMode = !!(window.Shopify && window.Shopify.designMode);

    /* Ensure searches are product-typed so Shopify exposes storefront filters
       (availability, price). Runs once — e.g. when arriving from the header
       search without a type. Skipped in the Theme Editor and when articles/pages
       are included. */
    if (!designMode && root.dataset.forceProduct === 'true') {
      try {
        var p = new URLSearchParams(window.location.search);
        if (p.get('q') !== null && p.get('type') !== 'product') {
          p.set('type', 'product');
          window.location.replace(window.location.pathname + '?' + p.toString());
          return;
        }
      } catch (e) {}
    }

    var form = root.querySelector('[data-srch-form]');
    if (!form) { return; }

    /* Sync the sort <select> with the current ?sort_by= param (search has no
       reliable Liquid property for the active sort). */
    var sort = form.querySelector('[data-srch-sort]');
    if (sort) {
      try {
        var params = new URLSearchParams(window.location.search);
        var cur = params.get('sort_by');
        if (cur) { sort.value = cur; }
      } catch (e) {}
    }

    function submitForm() { if (typeof form.requestSubmit === 'function') { form.requestSubmit(); } else { form.submit(); } }

    /* Sort applies immediately; filters apply via the Apply button. */
    if (sort) { sort.addEventListener('change', submitForm); }

    /* Dual-handle price slider(s), kept in sync with the currency number inputs. */
    var ranges = root.querySelectorAll('[data-srch-range]');
    Array.prototype.forEach.call(ranges, function (rng) {
      var minR = rng.querySelector('[data-srch-range-min]');
      var maxR = rng.querySelector('[data-srch-range-max]');
      var fill = rng.querySelector('[data-srch-range-fill]');
      var max = parseFloat(rng.getAttribute('data-max')) || 0;
      var body = rng.closest('.srch-acc__body') || rng.parentElement;
      var numMin = body.querySelector('[data-srch-price-min]');
      var numMax = body.querySelector('[data-srch-price-max]');
      if (!minR || !maxR || !max) { return; }

      function pct(v) { return max ? (v / max) * 100 : 0; }
      function paint() {
        var a = parseFloat(minR.value) || 0;
        var b = parseFloat(maxR.value); if (isNaN(b)) { b = max; }
        fill.style.left = pct(Math.min(a, b)) + '%';
        fill.style.right = (100 - pct(Math.max(a, b))) + '%';
      }
      minR.addEventListener('input', function () {
        if (parseFloat(minR.value) > parseFloat(maxR.value)) { minR.value = maxR.value; }
        if (numMin) { numMin.value = Math.round(parseFloat(minR.value)); }
        paint();
      });
      maxR.addEventListener('input', function () {
        if (parseFloat(maxR.value) < parseFloat(minR.value)) { maxR.value = minR.value; }
        if (numMax) { numMax.value = Math.round(parseFloat(maxR.value)); }
        paint();
      });
      if (numMin) {
        numMin.addEventListener('input', function () {
          var v = parseFloat(numMin.value); if (isNaN(v)) { v = 0; }
          if (v < 0) { v = 0; }
          if (v > max) { v = max; }
          minR.value = v; paint();
        });
      }
      if (numMax) {
        numMax.addEventListener('input', function () {
          var v = parseFloat(numMax.value); if (isNaN(v)) { v = max; }
          if (v > max) { v = max; }
          if (v < 0) { v = 0; }
          maxR.value = v; paint();
        });
      }
      paint();
    });

    /* Enter inside a price field applies filters. */
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target && e.target.matches('input[type="number"]')) {
        e.preventDefault();
        submitForm();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initSearch(document); });
  } else {
    initSearch(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initSearch(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
